module.exports = __webpack_public_path__ + "static/media/m2.8fe23399.jpg";